import axios from "axios";
import { authHeader } from "./auth-header";

const getAll = (keyword, page, perPage, id) => {
  return axios.get(process.env.REACT_APP_API_URL + `refund/list/${id}`, {
    headers: authHeader(),
    data: {},
    params: {
      keyword,
      page,
      perPage,
    },
  });
};

const getRefundsListing = (keyword, page, perPage) => {
  return axios.get(process.env.REACT_APP_API_URL + `refunds/list`, {
    headers: authHeader(),
    data: {},
    params: {
      keyword,
      page,
      perPage,
    },
  });
};

const getRefundDetails = (id) => {
  return axios.get(process.env.REACT_APP_API_URL + `refunds/view/${id}`, {
    headers: authHeader(),
    data: {},
  });
};

const exportRefunds = (filters = {}) => {
  return axios.get(process.env.REACT_APP_API_URL + `refunds/export`, {
    headers: authHeader(),
    responseType: "blob",
    params: filters,
  });
};

const methods = { getAll, getRefundsListing, getRefundDetails, exportRefunds };

export default methods;